import styled from 'styled-components';
const FlexDiv = styled.div `
  padding: ${(props) => props.padding || 0}rem;
  flex: ${(props) => props.flex || '0 1 auto'};
  display: flex;
  flex-flow: row wrap;
`;
FlexDiv.displayName = 'FlexDiv';
const FlexBaseDiv = styled(FlexDiv) `
  align-items: baseline;
`;
FlexBaseDiv.displayName = 'FlexBaseDiv';
const FlexStartDiv = styled(FlexDiv) `
  align-items: flex-start;
`;
FlexStartDiv.displayName = 'FlexStartDiv';
const FlexCenterDiv = styled(FlexDiv) `
  align-items: center;
`;
FlexCenterDiv.displayName = 'FlexCenterDiv';
const FlexEndDiv = styled(FlexDiv) `
 align-items: flex-end;
`;
FlexEndDiv.displayName = 'FlexEndDiv';
const FlexBaseSpacedDiv = styled(FlexBaseDiv) `
  justify-content: space-between;
`;
FlexBaseSpacedDiv.displayName = 'FlexBaseSpacedDiv';
const FlexStartSpacedDiv = styled(FlexStartDiv) `
  justify-content: space-between;
`;
FlexStartSpacedDiv.displayName = 'FlexStartSpacedDiv';
const FlexCenterSpacedDiv = styled(FlexCenterDiv) `
  justify-content: space-between;
`;
FlexCenterSpacedDiv.displayName = 'FlexCenterSpacedDiv';
const FlexEndSpacedDiv = styled(FlexEndDiv) `
 justify-content: space-between;
`;
FlexEndSpacedDiv.displayName = 'FlexEndSpacedDiv';
const FullWidthDiv = styled.div `
  width: 100%;
`;
const HiddenDiv = styled.div `
  display: none;
`;
HiddenDiv.displayName = 'HiddenDiv';
const PileDiv = styled.div `
  padding: ${(props) => props.padding || 0}rem;
  flex: ${(props) => props.flex || '0 1 auto'};
  display: flex;
  flex-direction: column;
`;
PileDiv.displayName = 'PileDiv';
const PileStartDiv = styled(PileDiv) `
 align-items: flex-start;
`;
PileStartDiv.displayName = 'PileStartDiv';
const PileCenterDiv = styled(PileDiv) `
 align-items: center;
`;
PileCenterDiv.displayName = 'PileCenterDiv';
const PileEndDiv = styled(PileDiv) `
 align-items: flex-end;
`;
PileEndDiv.displayName = 'PileEndDiv';
const PaddedDiv = styled.div `
  padding: ${(props) => props.padding || 1}rem;
`;
PaddedDiv.displayName = 'PaddedDiv';
const PaddedHorizontallyDiv = styled.div `
  padding-left: ${(props) => props.padding || 1}rem;
  padding-right: ${(props) => props.padding || 1}rem;
`;
PaddedHorizontallyDiv.displayName = 'PaddedHorizontallyDiv';
const PaddedVerticallyDiv = styled.div `
  padding-top: ${(props) => props.padding || 1}rem;
  padding-bottom: ${(props) => props.padding || 1}rem;
`;
PaddedVerticallyDiv.displayName = 'PaddedVerticallyDiv';
export { FlexDiv, FlexBaseDiv, FlexStartDiv, FlexCenterDiv, FlexEndDiv, FlexBaseSpacedDiv, FlexStartSpacedDiv, FlexCenterSpacedDiv, FlexEndSpacedDiv, FullWidthDiv, HiddenDiv, PileDiv, PileStartDiv, PileCenterDiv, PileEndDiv, PaddedDiv, PaddedHorizontallyDiv, PaddedVerticallyDiv };
